import { Box, Grid, Link, Paper, Typography } from "@mui/material";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";

const InfoCard = ({ title, value, icon = null, link = false }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: "12px",
        border: "1px solid #E4E7EC",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: 12,
            color: "#424752",
            fontWeight: 600,
            letterSpacing: 1,
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>

        {link ? (
          <Link
            href={`https://${value}`}
            target="_blank"
            underline="hover"
            sx={{
              fontSize: 20,
              fontWeight: 700,
              color: "#004790",
            }}
          >
            {value || "-"}
          </Link>
        ) : (
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "#111c2d",
              wordBreak: "break-word",
            }}
          >
            {value || "-"}
          </Typography>
        )}
      </Box>

      {icon && (
        <Box
          onClick={() => {
            if (value) {
              window.open(`https://${value}`, "_blank", "noopener,noreferrer");
            }
          }}
          sx={{
            cursor: value ? "pointer" : "default",
          }}
        >
          {icon}
        </Box>
      )}
    </Paper>
  );
};

export default function InfoTab({ organization = {}, contacts = [] }) {
  const primaryContact = contacts[0] || {};

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <InfoCard title="GSTIN Number" value={organization.gstin} />
      </Grid>

      <Grid item xs={12} md={6}>
        <InfoCard title="State" value={organization.state} />
      </Grid>

      <Grid item xs={12} md={6}>
        <InfoCard
          title="Location (State/City)"
          value={`${organization.state || "-"}, ${organization.city || "-"}`}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <InfoCard title="Pincode" value={organization.zipCode} />
      </Grid>

      <Grid item xs={12}>
        <InfoCard
          title="Web Domain"
          value={organization.domain}
          link
          icon={
            <OpenInNewOutlinedIcon
              sx={{
                color: "#667085",
              }}
            />
          }
        />
      </Grid>
    </Grid>
  );
}
